<template>
  <div>
    <Modal v-model="isShow" :class-name="z100000" :mask-closable="false" :loading="loading" @on-ok="ok" class="mask" width="650">
      <h3 slot="header" class="modal-header">修改ZO信息</h3>
      <Form :label-width="100" :model="formData" :rules="formRules" ref="formData">
        <FormItem label="项目" class="ivu-form-item-required">
          <Input class="input-width3" v-model="formData.projectName" :disabled="true"/>
        </FormItem>
        <FormItem label="手机号" prop="pzoPhone">
          <Input class="input-width2" v-model="formData.pzoPhone" @on-blur="onGetUserByPhone" />
        </FormItem>
        <FormItem label="员工姓名" prop="pzoName">
          <Input class="input-width2" v-model="formData.pzoName" disabled />
        </FormItem>
        <FormItem label="是否显示">
          <RadioGroup v-model="formData.pzoStatus">
            <Radio v-for="item in showList" :label="item.value" :key="'keyA'+item.value">{{item.text}}</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="ZO显示排序" prop="pzoOrder">
          <Input class="input-width2" v-model="formData.pzoOrder"/>
        </FormItem>
        <FormItem label="小头像" class="ivu-form-item-required">
          <img class="imgwidth" v-if="formData.pzoSmallimg" :src="formData.pzoSmallimg">
          <Upload class="upload"
                  :action="baseUrl+'/file/uploadFile'"
                  :on-success="handleSuccess0"
                  :headers="{'Access-Token':token}"
                  :show-upload-list="false"
                  :on-error="handleError"
                  :format="['jpg','jpeg','png']"
                  :on-format-error="formatError"

          >
            <Icon type="ios-plus-empty" size="40" style="vertical-align: middle"></Icon>
          </Upload>

        </FormItem>
        <FormItem label="大头像" class="ivu-form-item-required">
          <img class="imgwidth" v-if="formData.pzoBigimg" :src="formData.pzoBigimg">
          <Upload class="upload"
                  :action="baseUrl+'/file/uploadFile'"
                  :on-success="handleSuccess1"
                  :headers="{'Access-Token':token}"
                  :show-upload-list="false"
                  :on-error="handleError"
                  :format="['jpg','jpeg','png']"
                  :on-format-error="formatError"
          >
            <Icon type="ios-plus-empty" size="40" style="vertical-align: middle"></Icon>
          </Upload>
        </FormItem>
        <FormItem label="个人介绍">
          <Input class="input-width" type="textarea" v-model="formData.pzoIntroduction"/>
        </FormItem>

      </Form>
    </Modal>
  </div>
</template>

<script>
  import {getBaseUrl} from "../../../../utils/public";
  import {getToken} from "../../../../utils/auth";
  import {deepClone} from "../../../../utils/format";
  import {editProjectZO} from "../../../../api/projectConfig";
  import {getEHRUseInfo} from '@/api/managementCenter';
  import {mapGetters} from 'vuex';

  export default {
    name: "UpdateZO",
    props: {
      n: {
        type: Number,
        default: 0
      },
      formDataOri: {
        type: Object,
        default:null
      }
    },
    computed: {
      ...mapGetters([
        'empCode'
      ])
    },
    watch: {
      n() {
        this.formData=deepClone(this.formDataOri)

        this.$refs['formData']&& this.$refs['formData'].resetFields()
        this.isShow = true
      },
      formDataOri(value){
        if(!value){
          return
        }
        this.formData=deepClone(value)

      }
    },
    data() {
      return {
        validate: true,
        loading: true,
        token: '',
        baseUrl: '',
        showList: [{text: '是', value: 1}, {text: '否', value: 0}],
        z100000: 'z100000',
        isShow: false,
        formData: {},
        formRules: {
          pzoOrder: [
            {required: true, message: ' ', trigger: 'blur', validator: this.validateNumber}
          ],
          pzoName:[
            {required: true, message: ' ', trigger: 'blur', type:'string'}
          ],
          pzoPhone: [
            {required: true, message: ' ', trigger: 'blur', type: 'string'},
          ]
        }
      }
    },
    methods: {
      formatError(){
        this.$Message.info('请上传图片类型文件')
      },
      onGetUserByPhone() {
        getEHRUseInfo(this.formData.pzoPhone).then(res => {
          if (res.code === 0 && res.data.name) {          
            this.formData.pzoName = res.data.name;
             this.formData.pzoEmpCode = res.data.zoCode;
          } else {
            this.$Message.warning('手机号不存在');
          }
        }).catch(error => {});
      },
      ok() {
        this.$refs['formData'].validate(bool => {
          if (bool) {
            if(!this.formData.pzoSmallimg ||!this.formData.pzoBigimg ){
              this.$Message.info('请上传相关头像')
              this.changeLoading()
              return
            }
         //   this.formData.pzoEmpCode = this.empCode;
            editProjectZO(this.formData).then(res=>{
              this.$Message.success('ZO信息修改成功')
              this.$emit('editsuccess')
              this.isShow=false
            }).catch(error=>{
              this.changeLoading()

            })

          }
          else {
            this.changeLoading()
          }
        })


      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      validateNumber(rule, value, callback) {
        const pattern = /^\d+$/
        if (!pattern.test(value)) {
          callback(new Error('输入数字'));
        }
        callback();
      },
      handleSuccess0(response, file) {
        this.formData.pzoSmallimg = response.data.url
        this.formData.pzoSmallimgName = file.name
      },
      handleSuccess1(response, file) {
        this.formData.pzoBigimg = response.data.url
        this.formData.pzoBigimgName = file.name
      },
      handleError() {
      }

    },
    created() {
      this.baseUrl = getBaseUrl()
      this.token = getToken()
    }
  }
</script>

<style scoped>
  .input-width {
    width: 250px;
  }

  .input-width2 {
    width: 100px

  }

  .input-width3 {
    width: 150px;
  }
  .imgwidth{
    width: 100px;
    height: 70px;
    vertical-align: middle;
  }
  .upload {
    display: inline-block;
    width: 100px;
    height: 70px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;
    line-height: 70px;
    vertical-align: middle;
  }

</style>
